import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TabData } from '../../models';
import { Router } from '@angular/router';
import { HomeFacade } from '../../services/home.facade';

@Component({
  selector: 'app-search-tabs',
  templateUrl: './search-tabs.component.html',
  styleUrls: ['./search-tabs.component.scss'],
})
export class SearchTabsComponent {
  private readonly homeFacade = inject(HomeFacade);

  protected readonly tabs = this.homeFacade.tabs;

  @Output() selectTab = new EventEmitter<number>();
  @Input() currentTab: number = 0;

  constructor(private readonly router: Router) {}

  handleTabClick(event: MouseEvent, tab: TabData, index: number) {
    if (tab.staticTab) {
      this.activateStaticTab(event, index);
      return;
    }

    if (!tab.openExternally && tab.useRouterLink) {
      event.preventDefault();
      this.router.navigateByUrl(tab.url).then();
    }
  }

  private activateStaticTab(event: MouseEvent, index: number) {
    event.preventDefault();

    this.currentTab = index;
    this.selectTab.emit(index);
  }

  isActiveRoute(index: number): boolean {
    return this.currentTab === index;
  }
}
